jQuery(document).ready(function ($) {
  const other_ways_to_donate = localizedData.other_ways_to_donate;

  // OPEN POPUP and LOAD FORM via AJAX
  $(document).on("click", ".other-ways-to-donate", function (e) {
    e.preventDefault();
    var donate_type = $(this).attr("data-donate-type");

    $("#other-ways-to-donate-form-popup-wrapper").show();

    $.ajax({
      url: other_ways_to_donate.ajax_url,
      method: "POST",
      dataType: "json",
      data: {
        action: other_ways_to_donate.other_way_to_donate_form_action,
        nonce: other_ways_to_donate.other_way_to_donate_token,
      },
      success: function (response) {
        if (response.success && response.data.html) {
          $("#other-ways-to-donate-form-popup-wrapper").html(
            response.data.html
          );
          const $radio = $(
            'input[name="other_ways_to_donate"][id="' + donate_type + '"]'
          );
          $radio.prop("checked", true).trigger("change");
        } else {
          console.error("Unexpected response:", response);
        }
      },
      error: function (err) {
        console.error("AJAX error:", err);
      },
    });
  });

  // SUBMIT HANDLER
  $(document).on("submit", ".other-ways-to-donate-form", function (e) {
    e.preventDefault();

    let hasError = false;
    $(".error-message").text("");

    // Donation type selection
    const selectedDonationType = $(
      'input[name="other_ways_to_donate"]:checked'
    ).val();
    if (!selectedDonationType) {
      $("#donation-type-status")
        .text("Please select a donation option.")
        .css("color", "red");
      hasError = true;
    }

    // Interests checkboxes if visible
    if ($("#interests_wrapper").is(":visible")) {
      if ($("#interests_wrapper input[type='checkbox']:checked").length === 0) {
        $("#donation-interested-status")
          .text("Please select at least one interest option.")
          .css("color", "red");
        hasError = true;
      }
    }

    // First Name
    let firstName = $("#first-name").val().trim();
    if (!firstName) {
      $("#first-name-status")
        .text("First name is required.")
        .css("color", "red");
      hasError = true;
    }

    // Last Name
    let lastName = $("#last-name").val().trim();
    if (!lastName) {
      $("#last-name-status").text("Last name is required.").css("color", "red");
      hasError = true;
    }

    // Email
    let email = $("#email").val().trim();
    if (!email) {
      $("#email-status").text("Email is required.").css("color", "red");
      hasError = true;
    } else {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(email)) {
        $("#email-status")
          .text("Please enter a valid email address.")
          .css("color", "red");
        hasError = true;
      }
    }

    // Phone (optional)
    let phone = $("#phone").val().trim();
    if (phone && !/^\+?[0-9]{7,15}$/.test(phone)) {
      $("#phone-status")
        .text("Please enter a valid phone number (7–15 digits).")
        .css("color", "red");
      hasError = true;
    }

    if ($(".location-fields").is(":visible")) {
      if (!$("#town-city").val().trim()) {
        $("#town-city-status")
          .text("Town/City is required.")
          .css("color", "red");
        hasError = true;
      }
      if (!$("#owd_country").val().trim()) {
        $("#country-status").text("Country is required.").css("color", "red");
        hasError = true;
      }
    }

    if (hasError) {
      return; // Stop submission if errors
    }

    const formData = new FormData(this); // Add form fields to formData
    formData.append(
      "action",
      other_ways_to_donate.other_way_to_donate_form_submit_action
    );
    formData.append(
      "nonce",
      other_ways_to_donate.other_way_to_donate_form_submit_token
    );

    $.ajax({
      url: other_ways_to_donate.ajax_url,
      method: "POST",
      data: formData,
      processData: false,
      contentType: false,
      beforeSend: function () {
        $("#other-ways-form-loader").show(); // Show loader
        $("#other-ways-to-donate-form :input").prop("disabled", true); // Disable form inputs
      },

      success: function (response) {
        let statusEl = $("#form-status");
        if (statusEl.length === 0) {
          statusEl = $(
            '<div id="form-status" class="form-status"></div>'
          ).appendTo("body");
        }

        statusEl.removeClass("success error");

        if (response.success) {
          statusEl
            .html(
              '<i class="fas fa-check" style="color: green;"></i> Application submitted successfully!'
            )
            .addClass("success")
            .fadeIn();

          $("#other-ways-to-donate-form")[0].reset();
          $("#other-ways-to-donate-form-popup-wrapper").hide();
        } else {
          statusEl
            .html(
              '<i class="fas fa-exclamation-triangle" style="color: red;"></i> Submission failed: ' +
                response.message
            )
            .addClass("error")
            .fadeIn();
        }

        setTimeout(() => statusEl.fadeOut(), 5000);
      },
      error: function () {
        // If AJAX fails, show error message
        $("#form-status")
          .text("Submission failed. Please try again.")
          .css("color", "red");
      },
      complete: function () {
        $("#other-ways-form-loader").hide(); // Hide loader
        $("#other-ways-to-donate-form :input").prop("disabled", false); // Enable form inputs again
      },
    });
  });

  // RADIO BUTTON CHANGE HANDLER to show/hide interests
  $(document).on("change", 'input[name="other_ways_to_donate"]', function () {
    const selectedValue = $(this).val();

    if (selectedValue === "Become A Sponser") {
      $("#interests_wrapper").slideDown();
      $(".location-fields").slideDown();
    } else {
      $("#interests_wrapper").slideUp();
      $(".location-fields").slideUp();
      $("#donation-interested-status").text("");
      $("#town-city-status, #country-status").text("");
      $("#interests_wrapper input[type='checkbox']").prop("checked", false);
      $(".location-fields input").val("");
    }

    $("#donation-type-status").text(""); // Clear error when selecting
  });

  $(document).on("focus", "#owd_country", function () {
    if (!$(this).data("countrySelect")) {
      $(this).countrySelect({
        preferredCountries: ["gb", "us", "in", "ca"],
        defaultCountry: "gb"
      });
    }
  });

  // CLOSE POPUP
  $(document).on("click", ".other-ways-to-donate-close", function () {
    $("#other-ways-to-donate-form-popup-wrapper").hide();
  });
});
